import { Injectable } from '@angular/core'
import { CIDService } from './cid.service'

@Injectable()
export class PaymentService {
  currentCID: string

  constructor(private cIDService: CIDService) {
    this.currentCID = this.cIDService.getCID()
  }

  checkoutProcessing() {
    // console.log('Checkout is in process');
    // console.log(this.currentCID);
  }
}
